import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import ArticleHero from "@/components/ArticleHero";
import BreadcrumbSchema from "@/components/BreadcrumbSchema";
import { webPageSchema } from "@/components/schema";

const PATH = "/contact";
const TITLE = "Contact";
const DESCRIPTION =
  "How to reach the editorial desk at Spain Smile Guide — corrections, tips, clinic updates.";

export default function Contact() {
  return (
    <>
      <SEO
        title={TITLE}
        description={DESCRIPTION}
        path={PATH}
        type="website"
        jsonLd={webPageSchema(TITLE, DESCRIPTION, PATH)}
      />
      <BreadcrumbSchema
        items={[
          { name: "Home", path: "/" },
          { name: "Contact", path: PATH },
        ]}
      />

      <ArticleHero
        kicker="Publication"
        title="Contact the editorial desk"
        standfirst="One inbox. Corrections, clinic information updates, and editorial enquiries are handled here."
        datePublished="2026-04-18"
        dateModified="2026-04-18"
      />

      <div className="container-prose prose-editorial mt-10">
        <div className="border-y border-rule py-10">
          <div className="eyebrow mb-3">Editorial inbox</div>
          <a
            href="mailto:editor@spainsmileguide.com"
            className="font-serif text-[1.8rem] leading-none text-ink no-underline hover:underline"
          >
            editor@spainsmileguide.com
          </a>
          <p className="mt-4 text-small text-charcoal/70">
            Placeholder address. Point the MX records at a real inbox once
            the domain is registered — see{" "}
            <Link to="/about">About</Link> for the publication's operating
            posture.
          </p>
        </div>

        <h2>What to write about</h2>
        <p>
          The editorial desk reads correspondence on the following: factual
          corrections to published pieces; updates from clinics whose public
          positioning has changed since we last reviewed them; tips on
          practices that meet the rubric's standard and are not yet
          covered; reader questions we might address in a future piece.
        </p>

        <h2>What not to write about</h2>
        <p>
          Commercial offers — advertising, sponsored content, affiliate
          arrangements, listicle inclusion fees — are declined without
          reply. The publication does not accept commercial terms attached
          to coverage, and there is no mechanism on this site to do so.
        </p>

        <h2>Response times</h2>
        <p>
          Editorial correspondence is typically answered within one working
          week. Correction requests with a clear factual citation are
          prioritised.
        </p>
      </div>
    </>
  );
}
